/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.15",
    versionName: "local 0.2.0-nightly.2026.3.15",
    versionChannel: "local",
    buildDate: "2026-05-05T09:58:25.683Z",
    commitHash: "01703911feec78ecdda5ea1dc7ededac1ff74813",
};
